import { useLocation } from 'react-router-dom';

export default () => {
  const { pathname: href } = useLocation();

  return { href };
};
